import React, { useState, useRef, useEffect } from "react";
import "./dropdown.css";
import DropDownIcon from "../../Assets/Images/EployeeRegistration/icon-dropdown-menu.png";

export default function DropDown({
  width,
  label,
  setSelected,
  options,
  customWidth,
  customTop,
  isRequired,
  Height,
  OverFlow,
  minheight,
}) {
  const [isActive, setIsActive] = useState(false);
  const [selectedLabel, setSelectedLabel] = useState("");
  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsActive(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  const handleClick = (option) => {
    setSelected(option);
    setIsActive(false);
    setSelectedLabel(option.label);
  };

  return (
    <div className="dropdown" style={{ width }} ref={dropdownRef}>
      <label>
        {label}
        {isRequired && <span>*</span>}
      </label>
      <div
        className="dropdown-btn"
        onClick={() => setIsActive(!isActive)}
        style={{ width: customWidth }}
      >
        {selectedLabel}
        <img src={DropDownIcon} alt="dropdown-icon" />
      </div>
      {isActive && (
        <div
          className="dropdown-content"
          style={{
            width: customWidth,
            top: customTop,
            height: Height,
            overflow: OverFlow,
            maxHeight: minheight,
          }}
        >
          {options.map((option) => (
            <div
              key={option.id}
              className="dropdown-item"
              onClick={() => handleClick(option)}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
